import { createSelector } from 'reselect';
import { getCustomer, getTravellersValues } from '../../../../../Checkout/store/order/selectors';
import { getChildRefundWithoutAdultAllowed } from '../selectors';
import { getTravellerName, getUserValue } from '../../../../../utils';
import { TravellerFieldEnum } from '@websky/graphql';
import { buildRefundPassengers } from '../../lib/buildRefundPassengers';
import { buildRefundCheckboxPassengers } from '../../lib/buildRefundCheckboxPassengers';
import { getSelectedRefundFamiliesFromPassengers } from '../../lib/getSelectedRefundFamilies';
export const getPassengersState = (state) => state.refund.passengers;
export const getPassengersIds = createSelector(getPassengersState, Object.keys);
/**
 * Дополненная refund-модель пассажиров:
 * order travellers + `parentId` / `children` / `isSelected` / `isDisabled`
 */
export const getRefundPassengers = createSelector(getTravellersValues, getPassengersState, buildRefundPassengers);
/** Чекбоксы пассажиров для шага Passengers в формате `ExchangeRefundPassenger[]`. */
export const getRefundCheckboxPassengers = createSelector(getRefundPassengers, getChildRefundWithoutAdultAllowed, buildRefundCheckboxPassengers);
/** Проверяет, выбраны ли все пассажиры заказа */
export const getIsAllPassengersSelected = createSelector(getPassengersState, passengersState => Object.values(passengersState).every(value => value));
/** Есть ли хотя бы один выбранный пассажир */
export const getHasSelectedRefundPassengers = createSelector(getPassengersState, selection => Object.values(selection).some(Boolean));
/** String id выбранных пассажиров (GDS services и др.). */
export const getSelectedPassengersStringIds = createSelector(getPassengersState, selection => Object.entries(selection)
    .filter(([_, isSelected]) => isSelected)
    .map(([id]) => id));
/** Numeric id выбранных пассажиров для API refund. */
export const getSelectedPassengersNumericIds = createSelector(getSelectedPassengersStringIds, selectedPassengerIds => selectedPassengerIds.map(Number));
/** Выбранные пассажиры, сгруппированные по семейным связям (breadcrumbs, documents, contacts). */
export const getSelectedRefundFamilies = createSelector(getRefundPassengers, getSelectedRefundFamiliesFromPassengers);
/** Id семей для инициализации документов (одна семья на adult + детей). */
export const getSelectedRefundFamilyIds = createSelector(getSelectedRefundFamilies, selectedFamilies => selectedFamilies.map(family => family.id));
export const getInitialValuesContacts = createSelector(getCustomer, getSelectedRefundFamilies, (customer, selectedPassengersValues) => {
    var _a, _b;
    const { fullName, email, phone } = (_b = (_a = selectedPassengersValues[0]) === null || _a === void 0 ? void 0 : _a.values) !== null && _b !== void 0 ? _b : {};
    return {
        name: fullName || getTravellerName(customer),
        email: email || getUserValue(customer, TravellerFieldEnum.Email),
        phone: phone || getUserValue(customer, TravellerFieldEnum.Phone),
        comment: ''
    };
});
